<template>
    <div class="main">
      <van-overlay :show="show">
      <div class="wrapper"
           @click.stop>
        <div class="block">
          <van-loading color="#1989fa"
                       size="50px"
                       vertical>加载中...</van-loading>
        </div>
      </div>
    </van-overlay>
        <div class="m-hd">
            <span class="line"></span>
            物流药品订单配送分析
        </div>
        <van-tabs v-model="active" type="card">
            <van-tab :title=date2>
                <ul class="numList">
                    <li>
                        <div class="num">{{data3.rete*100 |moneyP}}%</div>
                        <div class="tt">及时配送率</div>
                    </li>
                    <li>
                        <div class="num">{{(1-data3.rete)*100 |moneyP}}%</div>
                        <div class="tt">缺货率</div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="本月累计">
                <ul class="numList">
                    <li>
                        <div class="num">{{data4.rete*100 |moneyP}}%</div>
                        <div class="tt">及时配送率</div>
                    </li>
                    <li>
                        <div class="num">{{(1-data4.rete)*100 |moneyP}}%</div>
                        <div class="tt">缺货率</div>
                    </li>
                </ul>
            </van-tab>
        </van-tabs>
        <div id="chart_1" :style="{ height: '200px'}"></div>
        <div class="m-hd">
            <span class="line"></span>
            医院药品价格策略利润分析(万)
        </div>
        <van-row class="f-rowhd">
            <van-col span="6">价格策略</van-col>
            <van-col span="6">销售金额</van-col>
            <van-col span="6">销售占比</van-col>
            <van-col span="6">毛利率</van-col>
        </van-row>
        <template>
            <van-row v-for="(item,index) in list" :key="item.id" class="f-row">
                <van-col span="6">
                    <van-tag type="primary" class="tag" :color="color[index]"></van-tag>
                    <span>{{ item.priceStrategy }}</span>
                </van-col>
                <van-col span="6">
                    <span>{{ item.sale/10000 | moneyP }}</span>
                </van-col>
                <van-col span="6">
                    <span>{{ item.sale *100 / totalSale | moneyP }}%</span>
                </van-col>
                <van-col span="6">
                    <span>{{ item.grossProfitRate *100 | moneyP }}%</span>
                </van-col>
            </van-row>
        </template>
        <div class="m-hd">
            <span class="line"></span>
            物流销售总利润分析(万)
        </div>
        <van-tabs v-model="active2" type="card">
            <van-tab title="本月">
                <ul class="numList">
                    <li>
                        <div class="num">{{data.sale/10000 |moneyP}}</div>
                        <div class="tt">本月销售总金额</div>
                    </li>
                    <li>
                        <div class="num">{{data.grossProfit/10000 |moneyP}}</div>
                        <div class="tt">毛利</div>
                    </li>
                    <li>
                        <div class="num">{{data.grossProfitRate*100 |moneyP}}%</div>
                        <div class="tt">毛利率</div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="本年累计">
                <ul class="numList">
                    <li>
                        <div class="num">{{data2.sale/10000 |moneyP}}</div>
                        <div class="tt">本年销售总金额</div>
                    </li>
                    <li>
                        <div class="num">{{data2.grossProfit/10000 |moneyP}}</div>
                        <div class="tt">毛利</div>
                    </li>
                    <li>
                        <div class="num">{{data2.grossProfitRate*100 |moneyP}}%</div>
                        <div class="tt">毛利率</div>
                    </li>
                </ul>
            </van-tab>
        </van-tabs>
        <div id="chart_2" :style="{ height: '200px'}"></div>
    </div>
</template>

<script>
import api from "@/axios/api";
import { moneyP2 } from "@/filter/money";
import { mapGetters, mapActions } from "vuex";

export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        token: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.startUp();
                }
            }
        }
    },

    data() {
        return {
            active: 0,
            active2: 0,
            date: this.$route.query.date,
            date2: this.$route.query.date.substring(5),
            data: {},
            data2: {},
            data3: {},
            data4: {},
            chartData: {
                date: [],
                data1: [],
                data2: []
            },
            monthList:[],
            dateM:[],
            mlList:[],
            proArr:[],

            list: [],
            //标签颜色
            color: [
                "rgb(71,122,255)",
                "rgb(90,200,242)",
                "rgb(255,166,70)",
                "rgb(74,237,128)",
                "rgb(147,130,251)"
            ],
            totalSale: 0,
            show: true
        };
    },
    methods: {
        getMonth() {
            let data = new Date(this.date);
            var year = data.getFullYear();
            var mon = data.getMonth() + 1;
            var arry = new Array();
            for (var i = 0; i < 6; i++) {
                if (mon <= 0) {
                    year = year - 1;
                    mon = mon + 12;
                }
                var mon2 = mon;
                if (mon < 10) {
                    mon = "0" + mon;
                }
                arry[i] = year + "-" + mon;
                mon = mon - 1;
            }
            return arry.reverse();
        },
        getTime() {
            this.monthList = this.getMonth();
            this.dateM = this.monthList.map(item => {
                let time = item.substring(5);
                return time;
            });
        },
        rate() {
            let param = {
                date: this.date
            };
            api.rate(param).then(res => {
                if (res.success) {
                    this.data3 = res.result;
                }
            });
        },
        rate2() {
            let time = this.date.substring(0, 7);
            let param = {
                date: time
            };
            api.rate(param).then(res => {
                if (res.success) {
                    this.data4 = res.result;
                }
            });
        },
        ratePlus() {
            let param = {
                date: this.date,
                recent: "7"
            };
            api.ratePlus(param).then(res => {
                if (res.success) {
                    //this.chartData.rows = res.result
                    let result = res.result;
                    for (let i = 0; i < result.length; i++) {
                        this.chartData.date.push(result[i].date.substring(5));
                        this.chartData.data1.push(
                            moneyP2(result[i].rete * 100)
                        );
                        this.chartData.data2.push(
                            moneyP2(100 - result[i].rete * 100)
                        );
                    }
                    this.drawChart1();
                }
            });
        },
        ratePlusSales() {
            let param = {
                date: this.date
            };
            api.ratePlusSales(param).then(res => {
                if (res.success) {
                    this.list = res.result;
                    for (let i = 0; i < res.result.length; i++) {
                        this.totalSale += res.result[i].sale;
                    }
                }
            });
        },
        merge() {
            let param = {
                date: this.date.substring(0, 7)
            };
            api.merge(param).then(res => {
                if (res.success) {
                    this.data = res.result;
                }
            });

            let param2 = {
                date: this.date.substring(0, 4)
            };

            api.merge(param2).then(res => {
                if (res.success) {
                    this.data2 = res.result;
                }
            });
        },
        drawChart1() {
            // 基于准备好的dom，初始化echarts实例
            let chart_1 = this.$echarts.init(
                document.getElementById("chart_1")
            );
            chart_1.setOption({
                tooltip: {
                    trigger: "axis",
                    formatter: function(params) {
                        var relVal = params[0].name;
                        for (var i = 0, l = params.length; i < l; i++) {
                            relVal +=
                                "<br/>" +
                                params[i].seriesName +
                                " : " +
                                params[i].value +
                                "%";
                        }
                        return relVal;
                    }
                },
                legend: {
                    data: ["及时配送率", "缺货率"]
                },
                grid: {
                    x: 50,
                    y: 40,
                    x2: 20,
                    y2: 20
                },
                xAxis: [
                    {
                        // name: "月",
                        // nameTextStyle: {
                        //     color: "#a6a6a6",
                        //     padding: [28, 0, 0, -25] // 四个数字分别为上右下左与原位置距离
                        // },
                        type: "category",
                        data: this.chartData.date,
                        axisLine: {
                            lineStyle: {
                                color: "#dedede"
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: "#a6a6a6"
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                color: "#dedede"
                            }
                        },
                        nameTextStyle: {
                            color: "#a6a6a6"
                        },
                        axisLabel: {
                            formatter: "{value}%",
                            textStyle: {
                                color: "#a6a6a6"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        //网格样式
                        splitLine: {
                            lineStyle: {
                                color: ["#dedede"],
                                width: 1,
                                type: "solid"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "及时配送率",
                        type: "bar",
                        stack: "率",
                        data: this.chartData.data1,
                        barWidth: 15,
                        itemStyle: {
                            normal: {
                                color: "#477aff"
                            }
                        }
                    },
                    {
                        name: "缺货率",
                        type: "bar",
                        stack: "率",
                        data: this.chartData.data2,
                        barWidth: 15,
                        itemStyle: {
                            normal: {
                                color: "#5fc8f3"
                            }
                        }
                    }
                ]
            });
        },
        promise(param) {
            return new Promise((resolve, reject) => {
                api.merge(param)
                    .then(res => {
                        resolve(res.result);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        getMerge() {
            for (let i = 0; i < this.monthList.length; i++) {
                let param = {
                    date: this.monthList[i]
                };
                this.proArr.push(this.promise(param));
            }
            Promise.all(this.proArr).then(res => {
                //console.log(res);
                for (let i = 0; i < res.length; i++) {
                    if(res[i] == null){
                        let a = 0;
                        this.mlList.push(a);
                    }else{
                        let a = moneyP2(res[i].grossProfit / 10000);
                        this.mlList.push(a);
                    }
                }
                this.drawChart2();
            });
        },
        drawChart2() {
            // 基于准备好的dom，初始化echarts实例
            let chart_2 = this.$echarts.init(
                document.getElementById("chart_2")
            );
            chart_2.setOption({
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['毛利']
                },
                grid: {
                    x: 50,
                    y: 40,
                    x2: 40,
                    y2: 30
                },
                xAxis: [
                    {
                        name:"月",
                        nameTextStyle: {
                            color:"#a6a6a6",
                            padding: [28, 0, 0, -25]    // 四个数字分别为上右下左与原位置距离
                        },
                        type: "category",
                        data: this.dateM,
                        axisLine: {
                            lineStyle: {
                                color: "#dedede"
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: "#a6a6a6"
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "万元         ",
                        //  min: 0,
                        // max: 2000,
                        //  interval: 200,
                        axisLine: {
                            lineStyle: {
                                color: "#dedede"
                            }
                        },
                        nameTextStyle: {
                            color: "#a6a6a6"
                        },
                        axisLabel: {
                            textStyle: {
                                color: "#a6a6a6"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        //网格样式
                        splitLine: {
                            lineStyle: {
                                color: ["#dedede"],
                                width: 1,
                                type: "solid"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "毛利",
                        type: "bar",
                        data: this.mlList,
                        barWidth: 15,
                        itemStyle: {
                            normal: {
                                color: "#36b3dc"
                            }
                        }
                    }
                ]
            });
            this.show = false;
        },
        startUp() {
            this.getTime();
            this.rate();
            this.rate2();
            this.ratePlus();
            this.ratePlusSales();
            this.merge();
            this.getMerge();
        }
    },
    mounted() {
        //this.startUp();
    }
};
</script>

<style lang="less" scoped>
.main {
    min-height: 100vh;
    background: #fff;
    .m-hd {
        position: relative;
        padding: 4vw 8vw;
        font-size: 16px;
        text-align: left;
        line-height: 1;
        .line {
            position: absolute;
            top: 50%;
            left: 3.4vw;
            transform: translateY(-50%);
            display: inline-block;
            width: 3px;
            height: 13px;
            background: #477aff;
        }
    }
    #chart_1,#chart_2 {
        margin: 4vw 0 0 0;
    }
    #chart_2 {
        padding: 0 0 4vw 0;
    }
    .numList {
        display: flex;
        padding: 6vw 0;
        background: #477aff;
        color: #fff;
        .num {
            margin-bottom: 4vw;
            font-size: 18px;
            line-height: 1;
        }
        .tt {
            font-size: 14px;
            color: #bbdefc;
            line-height: 1;
        }
        li {
            flex: 1;
        }
    }
    .f-row {
        padding: 2vw 0;
    }
    .f-rowhd {
        margin-bottom: 2vw;
        padding: 4vw 0;
        background: #477aff;
        color: #fff;
    }
    .tag {
        font-size: 15px;
        margin: 2px;
    }
    /deep/.van-tabs__nav {
        padding-left: 1vw;
    }

    /deep/.van-tab {
        flex: inherit;
        margin-left: 2.4vw;
        padding: 2vw 5.6vw;
        background: #36b3dc;
        color: #bbdefc;
        border-radius: 8px 8px 0 0;
        border-right: none;
    }
    /deep/.van-tabs__nav--card {
        margin: 0;
        border: none;
    }
    /deep/.van-tab--active {
        background: #477aff!important;
        color: #fff;
    }
}
</style>




// WEBPACK FOOTER //
// src/spd/logistics/reportPlus.vue